/** Venue deposit settings from API-normalized venue records. */
export const venueDepositEnabled = (venue) =>
  Boolean(venue?.deposit_enabled && Number(venue?.deposit_percent) > 0);

export const venueDepositPercent = (venue) => {
  const pct = Number(venue?.deposit_percent);
  return Number.isFinite(pct) && pct > 0 ? pct : null;
};

const roundPence = (amountMinor) => Math.round(amountMinor) / 100;

/**
 * Deposit due on venue hire subtotal (matches API: floor of subtotal_minor × percent).
 * Balance is the remainder of the full estimated charge (platform + processing on balance).
 */
export const computeVenueDepositQuote = (
  venue,
  { venueSubtotal, estimatedTotal },
  stripePaymentsEnabled
) => {
  if (!stripePaymentsEnabled || !venueDepositEnabled(venue)) return null;
  const percent = venueDepositPercent(venue);
  if (!percent) return null;

  const subtotal = Math.max(0, Number(venueSubtotal) || 0);
  const total = Math.max(0, Number(estimatedTotal) || 0);
  const subtotalMinor = Math.round(subtotal * 100);
  const depositMinor = Math.floor((subtotalMinor * percent) / 100);
  const depositDue = roundPence(depositMinor);
  const balanceDue = roundPence(Math.max(0, Math.round(total * 100) - depositMinor));

  if (depositDue <= 0 || balanceDue <= 0) return null;

  return {
    percent,
    depositDue,
    balanceDue,
    venueSubtotal: subtotal,
    estimatedTotal: total,
  };
};

export const bookingDepositDisclaimerLines = (depositQuote) => {
  if (!depositQuote) {
    return [
      "You won't be charged for this booking yet.",
      'A payment link will be sent to you only after the host verifies the inquiry',
    ];
  }
  const pctLabel = Number.isInteger(depositQuote.percent)
    ? String(depositQuote.percent)
    : depositQuote.percent.toFixed(1).replace(/\.0$/, '');
  return [
    `After you submit, you'll pay a ${pctLabel}% deposit (£${depositQuote.depositDue.toFixed(2)}) with Stripe before we send your inquiry to the venue.`,
    'The remaining balance (including Occasia platform and card processing fees) is due after the venue approves your request.',
  ];
};
